export default "__VITE_ASSET__4b64b0c4__"